export class Standort {
  constructor({
    id,
    name,
    storenummer,
  }: {
    id: string;
    name: string;
    storenummer: string | undefined;
  }) {
    this.id = id;
    this.name = name;
    this.storenummer = storenummer;
  }

  id: string;
  name: string;
  storenummer: string | undefined;
}
